import React, { useEffect, useState } from 'react';
import { FlexRow } from '@make-software/cspr-design';
import {
  EmptyMediaPlaceholder,
  LoadingMediaPlaceholder,
} from './NftMediaPlaceholder';

export const NftPreviewImage = ({ url, nftAlt }) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const onErrorHandler = (): void => {
    setLoading(false);
    setError(true);
  };

  const onLoadHandler = (): void => {
    setLoading(false);
  };

  useEffect(() => {
    if (url) {
      const img = new Image();
      img.src = url;
      img.onload = onLoadHandler;
      img.onerror = onErrorHandler;
    } else {
      onErrorHandler();
    }
  }, [url]);

  if (loading && !error) {
    return <LoadingMediaPlaceholder />;
  }

  if (error) {
    return <EmptyMediaPlaceholder />;
  }

  return (
    <FlexRow justify={'center'} grow={1}>
      <div
        style={{
          width: '100%',
          background: `url("${url}") center top no-repeat`,
          backgroundSize: `contain`,
        }}
        role={'img'}
        aria-label={nftAlt}
      />
    </FlexRow>
  );
};
